/* @flow */
import { getterFromKeyPath } from 'trustar/utils';
import {createSelector} from "reselect";
import {Map} from "immutable";

export const route = getterFromKeyPath(['router', 'locationBeforeTransitions']);
export const router = getterFromKeyPath(['router']);

export const currentBaseRoute = createSelector(
  [router],
  (router) => {
    const {pathname: location} = router.locationBeforeTransitions;
    const routeRungs = location.split('/').filter(string => !!string); // No empty strings por favor
    return routeRungs[0];
  });



// WEBPACK FOOTER //
// ./src/app/modules/router/getters.js